import styled from "styled-components";
import { Link } from "react-router-dom";

/** Conteneur principal du Navbar */
/** Conteneur principal du Navbar */
export const NavbarContainer = styled.header`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #15b5b0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 1000;
  min-height: 50px; /* Adaptable */

  @media (max-width: 768px) {
    justify-content: flex-start;
    align-items: center; /* Centrer le contenu */
  }
`;

/** Conteneur des liens de navigation */
export const NavLinks = styled.nav`
  display: flex;
  gap: 30px;

  @media (max-width: 768px) {
    display: none; /* Masqué en version mobile */
  }
`;

/** Style pour chaque lien de navigation */
export const NavLink = styled(Link)<{ active?: boolean }>`
  text-decoration: none;
  color: ${(props) => (props.active ? "#f7d07c" : "#ffffff")};
  font-weight: ${(props) => (props.active ? "bold" : "normal")};
  font-size: 1.1rem;
  transition: color 0.3s;

  &:hover {
    color: #eebba5;
  }
`;

/** Menu Burger */
export const BurgerMenu = styled.div`
  display: none;
  flex-direction: column;
  cursor: pointer;
  gap: 5px;
  position: relative;
  padding: 10px; /* Ajuste la zone cliquable */

  div {
    width: 30px;
    height: 3px;
    background-color: #ffffff;
    transition: all 0.3s ease-in-out;
    border-radius: 2px;
  }

  @media (max-width: 768px) {
    display: flex;
  }
`;

/** Menu Mobile */
export const MobileMenu = styled.div<{ open: boolean }>`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0; /* Change de right: 0 à left: 0 */
  width: 40%;
  height: 100vh;
  background: rgba(113, 164, 170, 0.95);
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2); /* Change l'ombre pour être à gauche */
  transform: ${({ open }) =>
    open ? "translateX(0)" : "translateX(-100%)"}; /* Change translateX */
  transition: transform 0.3s ease-in-out;
  padding: 20px;
  align-items: center;
  z-index: 999;
`;

/** Liens dans le menu mobile */
export const MobileNavLink = styled(Link)`
  color: #ffffff;
  font-size: 1.2rem;
  text-decoration: none;
  margin: 15px 0;
  transition: color 0.3s;

  &:hover {
    color: #f7d07c;
  }
`;
